import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise, AxiosResponse } from "axios";

const fetchByCategories = (courseId: number | string): AxiosPromise<CourseFinancesGroupedByCategoryApi> => {
  return api.get<CourseFinancesGroupedByCategoryApi>(endpoints.COURSE_FINANCES.GET_BY_CATEGORIES(courseId));
};
const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  courseIds?: number[],
): AxiosPromise<BaseApiPaging<CourseFinanceApi>> => {
  courseIds = courseIds ?? [];
  const ids = courseIds.filter((id) => id !== 0);

  const filter = ids.length > 0 ? `courseId in ('${ids.join(",")}')` : "";
  return api.get<BaseApiPaging<CourseFinanceApi>>(endpoints.COURSE_FINANCES.GET(skip, take, searchPhrase, filter));
};

const fetchById = (courseId: number, courseFinanceId: number): AxiosPromise<CourseFinanceApi> => {
  return api.get<CourseFinanceApi>(endpoints.COURSE_FINANCES.GET_BY_ID(courseId, courseFinanceId));
};
// TODO move file to folder
const downloadInvoice = (courseId: number, documentTemplateId: number): AxiosPromise<AxiosResponse<Blob>> => {
  return api.get(endpoints.COURSE_FINANCES.DOWNLOAD_INVOICE(courseId, documentTemplateId), {
    responseType: "blob",
  });
};
const fetchByCourseId = (courseId: number): AxiosPromise<CourseFinance[]> => {
  return api.get<CourseFinance[]>(endpoints.COURSE_FINANCES.GET_BY_COURSE_ID(courseId));
};
const create = (courseId: number, data: CreateCourseFinanseRequest): AxiosPromise<number> => {
  const formData = new FormData();

  formData.append("name", data.name);
  formData.append("courseFinanceCategoryId", data.courseFinanceCategoryId.toString());
  formData.append("date", data.date.toISOString());
  formData.append("value", data.value.toString());
  if (data.invoice) formData.append("invoice", data.invoice);

  return api.post<number>(endpoints.COURSE_FINANCES.CREATE(courseId), formData);
};

const update = (courseId: number, courseFinanceId: number, data: CreateCourseFinanseRequest): AxiosPromise<number> => {
  const formData = new FormData();

  formData.append("name", data.name);
  formData.append("courseFinanceCategoryId", data.courseFinanceCategoryId.toString());
  formData.append("courseId", data.courseId.toString());
  formData.append("date", data.date.toISOString());
  formData.append("value", data.value.toString());
  if (data.clearInvoice) formData.append("clearInvoice", data.clearInvoice.toString());
  if (data.invoice) formData.append("invoice", data.invoice);

  return api.put<number>(endpoints.COURSE_FINANCES.UPDATE(courseId, courseFinanceId), formData);
};

const deleteCourse = (courseId: number, courseFinanceId: number): Promise<void> => {
  return api.delete(endpoints.COURSE_FINANCES.DELETE(courseId, courseFinanceId));
};
export const courseFinancesApi = {
  fetch,
  fetchById,
  update,
  downloadInvoice,
  create,
  delete: deleteCourse,
  fetchByCategories,
  fetchByCourseId,
};

export interface CourseFinanceApi {
  id: number;
  name: string;
  date: Date;
  courseId: number;
  category: {
    id: number;
    name: string;
    isSystem: boolean;
  };
  courseName: string;
  value: number;
  invoice: string;
  userLinkedId?: number;
}

export interface CreateCourseFinanseRequest {
  id?: number;
  name: string;
  courseFinanceCategoryId: number;
  courseId: number;
  invoice?: File;
  date: Date;
  clearInvoice?: boolean;
  value: number;
}

export interface CourseFinancesCategoryApi {
  name: string;
  payments: CourseFinancesCategoryPaymentApi[];
  balance: number;
}

export interface CourseFinancesCategoryPaymentApi {
  name: string;
  value: number;
  date: Date;
}

export interface CourseFinancesGroupedByCategoryApi {
  balance: number;
  groups: CourseFinancesCategoryApi[];
}

export interface CourseFinance {
  id: number;
  name: string;
  value: number;
  date: Date;
  type: CourseFinanceType;
  hasInvoice: boolean;
  invoice?: string;
}
export const COURSE_FINANCES = {
  REGISTRATION: 1,
  EXAM: 2,
  OTHER: 3,
  RETAINED_REVENUE: 4,
  TRAINER_COST: 5,
  REFUND: 6,
} as const;
export type CourseFinanceType = (typeof COURSE_FINANCES)[keyof typeof COURSE_FINANCES];
